import { createSelector } from 'reselect';

/** @typedef {import('../types').PredefinedMessage} PredefinedMessage */

export const getRoot = state => state;

export const getState = state => state.predefinedMessages;

const getProps = (_, props) => props;

const getData = createSelector(getState, state => state.data);
export const getUI = createSelector(getState, state => state.ui);

/** @type {function():string} */
export const getByIdState = createSelector(getData, data => data.byId);

/** @type {function():PredefinedMessage} */
export const getById = createSelector(
  getByIdState,
  getProps,
  (state, predefinedMessageId) => state[predefinedMessageId]
);

/** @type {function():Array<PredefinedMessage>} */
export const getByIds = createSelector(getByIdState, getProps, (state, predefinedMessageIds) =>
  predefinedMessageIds.map(predefinedMessageId => state[predefinedMessageId]).filter(Boolean));

const getDataByDealerId = createSelector(getData, ({ byDealerId }) => byDealerId);
export const getPredefinedMessagesByDealerId = createSelector(
  getByIdState,
  getDataByDealerId,
  getProps,
  (dataById, dataByDealerId, dealerId) => dataByDealerId?.[dealerId]?.map(groupId => dataById?.[groupId] ?? {}) ?? []
);
